// CLZ QTY FIX — correct multi-currency quantity price display
//
// HOW PRICES WORK ON SHOPIFY MARKETS:
// 1. Liquid renders {{ price | money }} in USD (shop base currency)
// 2. Shopify's storefront currency.js converts <span class="money"> to local currency at page load
// 3. After conversion, the span text contains the correct local price e.g. "A$107.00"
// 4. data-unit-price on ATC button = raw USD cents (e.g. 8395 for $83.95 USD)
//
// THE BUG: Using Shopify.formatMoney(usdCents * qty) applies NO exchange rate
// — it just formats USD cents with the currency symbol, giving wrong non-USD amounts
//
// THE FIX: Read the converted display price from the already-converted money span
// Parse its numeric value, multiply by qty, reformat using the same symbol

(function() {

  // Parse a price string like "A$107.00", "€83.95", "£67.00", "$83.95" into cents
  function parsePriceToCents(str) {
    if (!str) return 0;
    // Remove all non-numeric chars except dot and comma
    var cleaned = String(str).replace(/[^0-9.,]/g, '');
    // Handle comma as decimal separator (e.g. "83,95")
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') === -1) {
      cleaned = cleaned.replace(',', '.');
    } else {
      // Remove thousands commas
      cleaned = cleaned.replace(/,/g, '');
    }
    return Math.round(parseFloat(cleaned) * 100);
  }

  // Reformat cents back to price string using the same currency prefix/suffix as original
  function formatFromSample(cents, sample) {
    var amount = (cents / 100).toFixed(2);
    // Extract the numeric part from sample to find prefix/suffix
    var numMatch = String(sample).match(/([^0-9]*)([0-9][0-9,. ]*)([^0-9]*)/);
    if (!numMatch) return String(cents / 100);
    var prefix = numMatch[1] || '';
    var suffix = numMatch[3] || '';
    return prefix + amount + suffix;
  }

  // Get the current display unit price string from the ATC button's money span
  // Falls back to data-unit-price with Shopify.formatMoney if span not found
  function getDisplayUnitPrice(sid) {
    var atcBtn = document.getElementById('clz-atc-' + sid);
    if (!atcBtn) return null;

    // Try to read from the .money span inside the button first
    var moneySpan = atcBtn.querySelector('.money');
    var displayStr = moneySpan ? moneySpan.textContent.trim() : null;

    // If no span, try reading textContent after the em dash
    if (!displayStr) {
      var txt = atcBtn.textContent || '';
      var dashIdx = txt.indexOf('\u2014');
      if (dashIdx > -1) displayStr = txt.slice(dashIdx + 1).trim();
    }

    return displayStr || null;
  }

  window.clzQty = function(delta, sid) {
    var inputs = [
      document.getElementById('clz-qty-' + sid),
      document.getElementById('clz-qty-mob-' + sid),
      document.getElementById('clz-mob-qty-' + sid)
    ];
    var newVal = 1;
    inputs.forEach(function(inp) {
      if (!inp) return;
      var v = Math.max(1, (parseInt(inp.value) || 1) + delta);
      inp.value = v;
      newVal = v;
    });

    var atcBtn = document.getElementById('clz-atc-' + sid);
    if (!atcBtn || atcBtn.classList.contains('oos')) return;

    // Get unit price in display currency from the button
    // We store it on the element as data-display-unit-price after first read
    var displayUnitStr = atcBtn.dataset.displayUnitPrice;
    if (!displayUnitStr) {
      displayUnitStr = getDisplayUnitPrice(sid);
      if (displayUnitStr) atcBtn.dataset.displayUnitPrice = displayUnitStr;
    }

    if (!displayUnitStr) return;

    var unitCents = parsePriceToCents(displayUnitStr);
    if (!unitCents || isNaN(unitCents)) return;

    var totalCents = unitCents * newVal;
    var totalFmt = formatFromSample(totalCents, displayUnitStr);
    var lbl = 'ADD TO BAG \u2014 ' + totalFmt;

    atcBtn.textContent = lbl;
    var mobAtc = document.getElementById('clz-mob-atc-' + sid);
    if (mobAtc && !mobAtc.classList.contains('oos')) mobAtc.textContent = lbl;
    var pillLbl = document.getElementById('clz-pill-lbl-' + sid);
    if (pillLbl) pillLbl.textContent = lbl;
    var drawerPrice = document.getElementById('clz-drawer-price-' + sid);
    if (drawerPrice) drawerPrice.textContent = totalFmt;
    var mobFormQty = document.getElementById('clz-mob-qty-' + sid);
    if (mobFormQty) mobFormQty.value = newVal;
  };

})();
